<template>
  <div class="styled-title font-family-glory font-weight-bold">
    <i v-if="align !== 'left'" class="line left" />
    <i-local-star-bold v-if="showStar" class="star left" />
    <span>
      <slot />
    </span>
    <i-local-star-bold v-if="showStar" class="star right" />
    <i v-if="align !== 'right'" class="line right" />
  </div>
</template>

<script setup lang="ts">
  const props = defineProps({
    showStar: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: 'center',
    },
    color: {
      type: String,
      default: '#fea922',
      note: 'color of the star and line',
    },
  })
  const flexGrow = props.width ? 0 : 1
  const widthStr = props.width ?? 'auto'
  const color = props.color
</script>

<style lang="scss" scoped>
  .styled-title {
    font-size: 36px; // default
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 4px;

    .line {
      display: inline-flex;
      height: 0.15em;
      background-color: v-bind(color);
      border-radius: 5px;
      flex-grow: v-bind(flexGrow);
      width: v-bind(widthStr);
    }
    .star {
      color: v-bind(color);
      font-size: 0.5em;
      min-width: 1em; // prevent it from shrinking under flex
    }
    > span {
      padding: 0 10px;
      line-height: 1em;
      margin: 0;
      white-space: nowrap;
      text-align: center;
    }
  }

  @media #{$mobile} {
    .styled-title {
      font-size: pxToRemMobile(30); // default
    }
  }
</style>
